import { G_optionFunctions } from "../../../utils/globals/globals";

/**
 *
 * @param {String} name
 * @param {PropertyValueProps} data
 * @param {MainClassProps} main
 */
const addStorageFunctions = (name, data, main) => {
  if (name && G_optionFunctions.has(name)) {
    const storage = /** @type {StorageFunctionProps} */ (main.storage.get("functions"));

    storage.push([name, data]);
  }
};

export default addStorageFunctions;
